import React from "react";

// reactstrap components
import { Container, Row, Col, Card, CardImg, Button } from "reactstrap";

// core components

// index page sections
import Hero from "../sub_components/Hero.js";
import Buttons from "../sub_components/Buttons.js";
import Inputs from "../sub_components/Inputs.js";
import CustomControls from "../sub_components/CustomControls.js";
import Menus from "../sub_components/Menus.js";
import Navbars from "../sub_components/Navbars.js";
import Tabs from "../sub_components/Tabs.js";
import Progress from "../sub_components/Progress.js";
import Pagination from "../sub_components/Pagination.js";
import Pills from "../sub_components/Pills.js";
import Labels from "../sub_components/Labels.js";
import Alerts from "../sub_components/Alerts.js";
import Typography from "../sub_components/Typography.js";
import Modals from "../sub_components/Modals.js";
import Datepicker from "../sub_components/Datepicker.js";
import TooltipPopover from "../sub_components/TooltipPopover.js";
import Carousel from "../sub_components/Carousel.js";
import Icons from "../sub_components/Icons.js";
import Login from "../sub_components/Login.js";
import Download from "../sub_components/Download.js";

import Paragraphs from "../sub_components/Paragraphs.js";

import { MultiLang, Determinator } from "react-multi-language";
import Navbar from "components_/sub_components/Navbar.js";

class AboutCLC extends React.Component {
  componentDidMount() {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.main.scrollTop = 0;
  }
  render() {
    return (
      <>
        <Navbar languageState={this.props.languageState} updateLanguageState={this.props.updateLanguageState} />
        {console.log("..[log - app.js, languageState] : ", this.props.languageState)}

        <main ref="main">
          <Carousel languageState={this.props.languageState} />

          {/* <section className="section ">
            <Container>
              <h3>
                <Determinator>
                  {{
                    en: "Message from AD / DSD",
                    tw: "渠務署助理署長寄語",
                    cn: "渠务署助理署长寄语",
                  }}
                </Determinator>
              </h3>
              <Row className="row-grid align-items-center">
                <Col md="9">
                  <div className="pl-md-5">
                    <p className="lead">
                      <Determinator>
                        {{
                          en: "comming soon ...",
                          tw: "準備中 ...",
                          cn: "准备中 ...",
                        }}
                      </Determinator>
                    </p>
                    <br />
                  </div>
                </Col>
                <Col md="3">
                  <Card className="bg-default shadow border-0">
                    <CardImg
                      alt="..."
                      src={require("assets_/img_/activities/i360_202004_steel_bridge_view1_4096.jpg")}
                      top
                    />
                  </Card>
                </Col>
              </Row>
              <br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
              <br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
            </Container>
          </section> */}

          {/* <section className="section bg-secondary"> */}
          <section className="section">
            <Container>
              <Row className="row-grid align-items-center">
                <Col md="12">
                  {/* <h3>
                    <Determinator>
                      {{
                        en: "Contact Us",
                        tw: "聯絡我們",
                        cn: "联络我们",
                      }}
                    </Determinator>
                  </h3> */}

                  {/* <Card className="card-profile shadow mt--300"> */}
                  <Card className="card-profile shadow ">
                    <div className="px-4">
                      <Row className="justify-content-center">
                        {/* <Col className="order-lg-2" lg="3">
                      <div className="card-profile-image">
                        <a href="#pablo" onClick={e => e.preventDefault()}>
                          <img
                            alt="..."
                            className="rounded-circle"
                            src={require("assets_/img_/activities/i360_202004_steel_bridge_view1_4096.jpg")}
                          />
                        </a>
                      </div>
                    </Col> */}
                        {/* <Col
                      className="order-lg-3 text-lg-right align-self-lg-center"
                      lg="4"
                    >
                      <div className="card-profile-actions py-4 mt-lg-0">
                        <Button
                          className="mr-4"
                          color="info"
                          href="#pablo"
                          onClick={e => e.preventDefault()}
                          size="sm"
                        >
                          Connect
                        </Button>
                        <Button
                          className="float-right"
                          color="default"
                          href="#pablo"
                          onClick={e => e.preventDefault()}
                          size="sm"
                        >
                          Message
                        </Button>
                      </div>
                    </Col> */}
                        {/* <Col className="order-lg-1" lg="4">
                      <div className="card-profile-stats d-flex justify-content-center">
                        <div>
                          <span className="heading">22</span>
                          <span className="description">Friends</span>
                        </div>
                        <div>
                          <span className="heading">10</span>
                          <span className="description">Photos</span>
                        </div>
                        <div>
                          <span className="heading">89</span>
                          <span className="description">Comments</span>
                        </div>
                      </div>
                    </Col> */}
                      </Row>
                      <div className="text-center mt-5">
                        {/* <h3>
                      Jessica Jones{" "}
                      <span className="font-weight-light">, 27</span>
                    </h3>
                    <div className="h6 font-weight-300">
                      <i className="ni location_pin mr-2" />
                      Bucharest, Romania
                    </div>
                    <div className="h6 mt-4">
                      <i className="ni business_briefcase-24 mr-2" />
                      Solution Manager - Creative Tim Officer
                    </div>
                    <div>
                      <i className="ni education_hat mr-2" />
                      University of Computer Science
                    </div> */}
                        <h3>
                          <Determinator>
                            {{
                              en: "Community Liaison Team",
                              tw: "社區聯絡小組",
                              cn: "社区联络小组",
                            }}
                          </Determinator>{" "}
                        </h3>
                        <p className="lead">
                          {/* <br />
                          <Determinator>
                            {{
                              en: "Location: No. 21 Hang Tai Road, Ma On Shan",
                              tw: "地址: 馬鞍山恆泰路21號",
                              cn: "地址：马鞍山恒泰路21号",
                            }}
                          </Determinator> */}
                          <br />
                          <Determinator>
                            {{
                              en: "Telephone:     (852) 5220 0180",
                              tw: "聯絡電話：   (852) 5220 0180",
                              cn: "联络电话：   (852) 5220 0180",
                            }}
                          </Determinator>
                          {/* <br />
                          <Determinator>
                            {{
                              en: "Fax: (852) 3914 5888",
                              tw: "傳真：（852）3914 5888",
                              cn: "传真：（852）3914 5888",
                            }}
                          </Determinator> */}
                          <br />
                          <Determinator>
                            {{
                              en: "E-mail: pr@stc-aecom.com",
                              tw: "電郵：pr@stc-aecom.com",
                              cn: "电邮：pr@stc-aecom.com",
                            }}
                          </Determinator>
                          {/* <br />
                          <br />
                          <Determinator>
                            {{
                              en: "Office Hour (Mon to Fri, except for public holiday) :",
                              tw: "辦公時間（星期一至星期五，公眾假期除外）：",
                              cn: "办公时间（星期一至星期五，公众假期除外）：",
                            }}
                          </Determinator>
                          <br />
                          <Determinator>
                            {{
                              en: "09:00 am to 12:00 noon and ",
                              tw: "上午9時　至　中午12時　及",
                              cn: "上午9时　至　中午12时　及",
                            }}
                          </Determinator>
                          <br />
                          <Determinator>
                            {{
                              en: "1:00 pm to 6:00 pm ",
                              tw: "下午1時　至　下午6時",
                              cn: "下午1时　至　下午6时",
                            }}
                          </Determinator> */}
                        </p>
                      </div>
                      <div className="mt-5 py-5 border-top text-center">
                        <Row className="justify-content-center">
                          <Col lg="9">
                            <Button
                              className="btn-icon-only rounded-circle ml-1"
                              color="facebook"
                              href="https://zh-hk.facebook.com/STSTWinCaverns"
                              id="tooltip837440414"
                              target="_blank"
                            >
                              <span className="btn-inner--icon">
                                <i className="fa fa-facebook-square" />
                              </span>
                            </Button>
                          </Col>
                        </Row>
                        <br />

                        <Row className="justify-content-center">
                          <Col lg="9">
                            {/* <p className="lead"> */}
                            <h15>
                              <Determinator>
                                {{
                                  en: "Project Website: ",
                                  tw: "項目網址：",
                                  cn: "项目网址：",
                                }}
                              </Determinator>
                              <br />
                              <a href="https://www.ststwincaverns.hk/">https://www.ststwincaverns.hk/</a>
                              <br />
                              <Determinator>
                                {{
                                  en: "Stage 1 Contract Website: ",
                                  tw: "第一階段工程網址：",
                                  cn: "第一阶段工程网址：",
                                }}
                              </Determinator>
                              <br />
                              <a href="https://www.ststwincavernss1.hk/">https://www.ststwincavernss1.hk/</a>
                            </h15>
                            {/* </p> */}
                            {/* <a href="#pablo" onClick={e => e.preventDefault()}>
                          Show more
                        </a> */}
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
        </main>
        <MultiLang lang={this.props.languageState.lang} />
      </>
    );
  }
}

export default AboutCLC;
